export const DxfService = {
    getColorFromEntity: (data: any): string => {
        let rgbStr = '0,0,0';
        if (data.color && data.color !== '0,0,0') {
            rgbStr = data.color;
        }
        return rgbStr;
    },
};
